export const emailRegex = /^[\w\.\-]+(?:\+[\w\.\-]+)?@([\w\-]+\.)+[\w\-]{2,4}$/
export const phoneRegex = /^(\+27|0)[0-9]{9}$/
export const idRegex = /^[0-9]{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12][0-9]|3[01])[0-9]{6}[0-9]{1}$/
export const passportRegex = /^[A-Z]{2}\d{6}$/
export const postalCodeRegex = RegExp(/^\d{4}$/)